import { render, staticRenderFns } from "./MallHotelBrandCategory.vue?vue&type=template&id=75c8d0d6&scoped=true&"
import script from "./MallHotelBrandCategory.vue?vue&type=script&lang=js&"
export * from "./MallHotelBrandCategory.vue?vue&type=script&lang=js&"
import style0 from "./MallHotelBrandCategory.vue?vue&type=style&index=0&id=75c8d0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8d0d6",
  null
  
)

export default component.exports